export interface PrintOptions {
  doNotPrint: boolean
  emphasize: boolean
  printDescription: boolean
  previewImage: boolean
  imageOverrides: Record<string, boolean>
}

export const defaultPrintOptions: PrintOptions = {
  doNotPrint: false,
  emphasize: false,
  printDescription: false,
  previewImage: false,
  imageOverrides: {},
} as const
